import {
  HANDOFF,
  OPEN_CASH_DRAWER,
  REGISTER_PAYMENT_HANDLER,
  STRIPE_CONNECT_TOKEN,
  HANDOFF_UPDATE_KIOSK_CART,
  HANDOFF_RESET_KIOSK_CART,
} from './constants';
import Http from '../http';
import iosBridge from './iosBridgeService';

export const openCashDrawer = () => ({ type: OPEN_CASH_DRAWER });

const sendConnectionToken = token => new Promise((resolve) => {
  iosBridge.callHandler(
    'stripe://connect',
    token,
    ({ success }) => resolve(success),
  );
});

export const handleStripeConnectToken = async () => {
  const token = await Http.post('/pos/connection-token');
  return sendConnectionToken(token);
};

export const stripeConnectTokenAction = strategy => ({
  type: STRIPE_CONNECT_TOKEN,
  strategy,
});

export const registerPaymentHandler = () => ({
  type: REGISTER_PAYMENT_HANDLER,
});

export const handoff = payload => ({
  type: HANDOFF,
  payload,
});

export const handoffUpdateKioskCart = payload => ({
  type: HANDOFF_UPDATE_KIOSK_CART,
  payload,
});

export const handoffResetKioskCart = () => ({
  type: HANDOFF_RESET_KIOSK_CART,
});
